@if (items?.length > 0) {
<ng-container>
    <div [formGroup]="group" class="no-underline d-flex flex-column">
        @if (textLabel) {
        <label [for]="fcName" [ngClass]="{ star: required }" class="item-label"
            >{{ textLabel }}
        </label>
        }

        <mat-select
            [disabled]="disabled"
            [formControlName]="fcName"
            [id]="fcName"
            [ngClass]="{ 'is-invalid': error, disabled: control.disabled }"
            class="custom-select"
            multiple
            placeholder="{{ placeholder }}"
        >
            <mat-select-trigger [matTooltip]="tooltipFormatted">
                {{ formatedControlValue }}
            </mat-select-trigger>
            @for (item of items; track item.id) {
            <mat-option
                [value]="item.id"
                [disabled]="item.selectable === false"
                class="select-item"
                >{{ item.name }}</mat-option
            >
            }
        </mat-select>

        @if (error) {
        <div class="invalid-submit">
            <div>{{ errorMsg }}</div>
        </div>
        }
    </div>
</ng-container>
}
